import api from '../../../api/clinique/_medecins_demandeurs'
import api_config from '../../../api/config/_config'
import { annuaireMedecins, resoudre } from '@/utils/medecin-demandeur'

// CAISSE-VDF-3 : médecin demandeur des lignes d'une facture. Les noms recopiés dans la Clinique sont pris tels quels ;
// un identifiant seul est résolu avec l'annuaire du personnel (médecins uniquement). L'annuaire est gardé en mémoire et
// rechargé s'il date de plus de 5 minutes quand un auteur y est inconnu (médecin ajouté depuis) ; s'il ne peut pas être
// chargé, seuls les noms recopiés sont affichés.
const FRAICHEUR_MS = 5 * 60 * 1000
let annuaire = null
let charge_a = 0

function chargerAnnuaire() {
    return api_config.getRolePersonnels().then((personnels) => {
        annuaire = annuaireMedecins(personnels)
        charge_a = Date.now()
        return annuaire
    })
}

export default {
    getMedecinsDemandeurs(uids, patient_id) {
        if (!Array.isArray(uids) || !uids.length) return Promise.resolve({})
        return api.parUids(uids, patient_id).then((reponse) => {
            if (!reponse || reponse.success !== true || !reponse.data) throw new Error('Réponse invalide')
            const lignes = reponse.data
            const idSeul = m => !!m && !m.medecin_nom && !!m.medecin_id
            const besoin = Object.keys(lignes).some(uid => idSeul(lignes[uid]) || (lignes[uid] && !lignes[uid].medecin_nom && idSeul(lignes[uid].repli)))
            if (!besoin) return resoudre(lignes, {})
            const inconnu = a => Object.keys(lignes).some(uid => idSeul(lignes[uid]) && !a[String(lignes[uid].medecin_id)])
            const perime = annuaire && inconnu(annuaire) && Date.now() - charge_a > FRAICHEUR_MS
            const chargement = annuaire && !perime ? Promise.resolve(annuaire) : chargerAnnuaire()
            return chargement.then(a => resoudre(lignes, a), () => resoudre(lignes, null))
        })
    },

    // Tests et changement d'établissement
    oublierAnnuaire() {
        annuaire = null
        charge_a = 0
    }
}
